import { gql } from 'graphql-tag';
import type { TypedDocumentNode } from '@apollo/client';
import type { IGetAvailableEventsQueryData, IGetAvailableEventsQueryVars } from '../types';

export const GET_AVAILABLE_EVENTS_QUERY: TypedDocumentNode<IGetAvailableEventsQueryData, IGetAvailableEventsQueryVars> =
  gql`
    query getAvailableEventsQuery($input: AvailableEventsQueryInput!) {
      availableEventsQuery(input: $input) {
        events {
          asmtEventId
          asmtEventTypeCd
          asmtId
          asmtSubtypeCd
          eventEndDt
          eventStartDt
          eventTitle
          tdtkAsmtType
        }
      }
    }
  `;
